module.exports = __webpack_public_path__ + "img/sync-outline.6484f487.svg";